import React, { Component } from 'react';
import { connect } from 'react-redux';
import ShippingCountryWrapper from './ShippingCountryWrapper';
import GlobeImg from './GlobeImg';
import BorderArrowUp from './BorderArrowUp';
import ChangeShipping from '../../ChangeShipping/ChangeShipping';
import {
  showChangeShippingCountry,
  hideChangeShippingCountry,
} from '../../../modules/manageChangeShippingCountrySelector';
import ChangeShippingCountryWrapper from './ChangeShippingCountryWrapper';
import { Desktop } from '../../MediaQuery';
import Store from '../../../common/models/Store';

interface ShippingCountryProps {
  countryIso: string;
  hideChangeShipping: () => void;
  isChangeShippingCountryVisible: boolean;
  s3BasePath: string;
  showChangeShipping: () => void;
}

const mapStateToProps = ({ api: { countryIso, s3BasePath }, isChangeShippingCountryVisible }: Store) => ({
  countryIso,
  isChangeShippingCountryVisible,
  s3BasePath,
});

const mapDispatchToProps = dispatch => ({
  hideChangeShipping: () => dispatch(hideChangeShippingCountry()),
  showChangeShipping: () => dispatch(showChangeShippingCountry()),
});

class ShippingCountry extends Component<ShippingCountryProps> {
  private labelGlobeRef: React.RefObject<HTMLDivElement>;

  private changeShippingRef: React.RefObject<HTMLDivElement>;

  constructor(props: ShippingCountryProps) {
    super(props);

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleChangeShippingVisible = this.handleChangeShippingVisible.bind(this);
    this.labelGlobeRef = React.createRef<HTMLDivElement>();
    this.changeShippingRef = React.createRef<HTMLDivElement>();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleChangeShippingVisible() {
    const { isChangeShippingCountryVisible, showChangeShipping, hideChangeShipping } = this.props;
    if (!isChangeShippingCountryVisible) {
      showChangeShipping();
    } else {
      hideChangeShipping();
    }
  }

  handleClickOutside(event) {
    const { hideChangeShipping } = this.props;
    const clickOutsidePopup =
      this.changeShippingRef &&
      this.changeShippingRef.current &&
      !this.changeShippingRef.current.contains(event.target);
    const clickOutsideCountryGLobe =
      this.labelGlobeRef && this.labelGlobeRef.current && !this.labelGlobeRef.current.contains(event.target);

    if (clickOutsidePopup && clickOutsideCountryGLobe) {
      hideChangeShipping();
    }
  }

  render() {
    const { countryIso, s3BasePath, isChangeShippingCountryVisible } = this.props;
    return (
      <div style={{ position: 'relative' }}>
        <Desktop>
          <ShippingCountryWrapper
            ref={this.labelGlobeRef}
            data-cy="header-shipping-country-label"
            onClick={this.handleChangeShippingVisible}
          >
            <span style={{ color: '#999', marginRight: '5px' }}>{countryIso}</span>
            <GlobeImg data-cy="image-search-open" src={`${s3BasePath}mkt/header/globe.svg`} />
          </ShippingCountryWrapper>
        </Desktop>
        {isChangeShippingCountryVisible && (
          <ChangeShippingCountryWrapper ref={this.changeShippingRef}>
            <Desktop>
              <BorderArrowUp />
            </Desktop>
            <ChangeShipping />
          </ChangeShippingCountryWrapper>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShippingCountry);
